<template>
  <div>
    <div v-if="isLoading" class="text-center py-5 text-secondary">
      {{ $t("loadingData") }}
    </div>

    <template v-if="!isLoading">
      <div class="d-flex flex-row align-items-center justify-content-between mb-4">
        <h5 class="m-0">{{ $t("manageGMTokenTitle") }}</h5>
      </div>

      <b-table :items="adminUsers" hover primary-key="id" :fields="tableFields" show-empty>
        <template v-slot:empty>
          <div class="text-center text-secondary py-4">{{ $t("noData") }}</div>
        </template>
        <template v-slot:cell(token)="data">
          <div v-if="data.item.tokenInfo" class="max-width-col" v-b-tooltip :title="data.item.tokenInfo.token">
          {{data.item.tokenInfo.token}}
          </div>
        </template>
        <template v-slot:cell(expired)="data">
          <div v-if="data.item.tokenInfo">
          {{ localDateFormat(data.item.tokenInfo.expired) }}
          </div>
        </template> 
        <template v-slot:cell(actions)="data">
          <b-dropdown size="lg" variant="link" toggle-class="text-decoration-none p-0" no-caret right menu-class="shadow">
            <template v-slot:button-content>
              <b-icon icon="three-dots"/>
            </template>     
            <b-dropdown-item-button @click="createToken(data.item)">Tạo token</b-dropdown-item-button>       
            <b-dropdown-item-button v-if="checkCustomerUserHasGMToken(data.item)" @click="evictToken(data.item)">Thu hồi token</b-dropdown-item-button>
          </b-dropdown>
        </template>
      </b-table>
    </template>
  </div>
</template>

<style lang="scss" scoped>
  .max-width-col {
    max-width: 350px;
    white-space: nowrap;
    overflow: hidden;
    text-overflow: ellipsis;
  }

</style>

<script lang="ts">
  import {Component} from 'vue-property-decorator';
  import _ from "lodash";
  import BaseComponent from "@/components/BaseComponent";
  import {BvTableFieldArray} from "bootstrap-vue";
  import * as userService from "@/service/userService";
  import * as customerService from "@/service/customerService";


  @Component({
    components: { }
  })
  export default class CustomerToken extends BaseComponent {

    ///
    readonly ALLOW_GM_TOKEN = 1;
    readonly CUSTOMER = 'Customer';

    id: number = null;

    isLoading = false;

    adminUsers = [];
    tableFields: BvTableFieldArray = [
      {
        key: "id",
        label: "#"
      },
       {
        key: "name",
        label: "Tên"
      },
      {
        key: "username",
        label: this.$t("account").toString(),
        thClass: "text-nowrap",
        tdClass: "text-nowrap"
      },
      {
        key: "token",
        label: "Token",
      },
      {
        key: "expired",
        label: this.$t("expireDate").toString(),
        thClass: "text-nowrap",
        tdClass: "text-nowrap",
      },
      {
        key: "actions",
        label: ""
      }
    ];

    mounted() {
      this.id = +this.$route.params.id || null;
      this.fetchCustomer();
    }

    async fetchCustomer() {
      try {
        this.isLoading = true;

        const fetchAdminUsersPromise = userService.getCustomerAdmins(this.id);

        this.adminUsers = (await fetchAdminUsersPromise).filter(s => s.role === this.CUSTOMER);
        
        ///
        this.handleAdminUsers(this.adminUsers);

      } catch (e) {
        this.toastError(e);

      } finally {
        this.isLoading = false;
      }
    }

    async handleAdminUsers(adminUsers: any[]) {

      ///
      const ADMIN = 'Manager';
      for (const index in adminUsers) {
        const user = adminUsers[index];
        if (user.role === ADMIN || user.role === this.CUSTOMER) {          
          try {
            const tokenInfo = await customerService.getGMTokenByUser(user.id);
            user.tokenInfo = tokenInfo;
          } catch (error) {
          }
        }
      }

      this.adminUsers = [...adminUsers];      
    }

    /// Kiểm tra tài khoản user của khách hàng có thông tin GMToken
    checkCustomerUserHasGMToken(user) {      
      return user.tokenInfo != null && user.tokenInfo.token;
    }

    async createToken(data) {      
      try {
        const res = await customerService.createCustomerUserToken(data.id);
        if (res.code === 0) {
          this.toastSuccessDelay(this.$t("success").toString());
          const findUser = this.adminUsers.find(s => s.id === data.id);

          findUser.tokenInfo = res.data;

          this.adminUsers = [...this.adminUsers];
          
        } else {
          this.toastError(res);
        }
      } catch (e) {
        this.toastError(e);
      }
    }

    async evictToken(data) {      
      try {
        const res = await customerService.evictCustomerUserToken(data.id);
        if (res.code === 0) {
          this.toastSuccessDelay(this.$t("success").toString());

          const findUser = this.adminUsers.find(s => s.id === data.id);

          findUser.tokenInfo = null;

          this.adminUsers = [...this.adminUsers];
        } else {
          this.toastError(res.message);
        }
      } catch (e) {
        this.toastError(e);
      }
    }
  }
</script>
